import React from 'react';
import PropTypes from 'prop-types';
import {navigate} from 'gatsby';
import * as styles from '../Styles/search.module.scss';
import * as trackAction from '../../Application/Shared/TrackActionService';
import {Highlight} from 'react-instantsearch-dom';
import htmr from 'htmr';

const SearchCard = ({hit}) => {
  const navigateToCoursePage = (data) => {
    trackAction.ctaClickAction({
      'cta': data['course_slug'],
      'action': 'CourseCardClicked',
    });
    navigate(data.website_url);
  };
  return (
    <div className={styles.cardBox}>
      <div className={styles.cardDetails}>
        <div className={styles.cardImg}>
          <div className={styles.link}
            onClick={()=>navigateToCoursePage(hit)}>
            <img src={hit.image}
              className={styles.desktopView}
              data-src={hit.image}
              alt="hit"
            />
          </div>
        </div>
        <div className={styles.cardContent}>
          <div className={styles.heading}
            onClick={()=>navigateToCoursePage(hit)}>
            {hit.faculty_name}:&nbsp;
            <Highlight attribute='course_title' hit={hit}/>
          </div>
          <div className={styles.courseName}>
            <p>Lesson {hit.lesson_number}</p>
            <div className={`library-brand-icon-new`}>
              <i className="icon-new-right-arrow"></i>
            </div>
            <span>{hit.lesson_name}</span>
          </div>
          <p>
            {htmr(hit?.lesson_description)}
          </p>
        </div>
      </div>
    </div>
  );
};


SearchCard.propTypes = {
  hit: PropTypes.object,
};


export default SearchCard;
